import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { I18nService } from '../../../../shared/services/i18n.service';

export interface TabItem {
  label: string;
  route: string;
}

@Component({
  selector: 'app-vertical-tabs',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, TranslateModule],
  templateUrl: './vertical-tabs.html',
  styleUrl: './vertical-tabs.scss'
})
export class VerticalTabsComponent implements OnInit {
  tabs: TabItem[] = [];

  constructor(private i18n: I18nService) {}

  ngOnInit() {
    this.tabs = [
      { label: 'client.navigation.my_orders', route: this.i18n.generateUrlWithLang('client/orders') },
      { label: 'client.navigation.my_projects', route: this.i18n.generateUrlWithLang('client/projects') },
      { label: 'client.navigation.addresses', route: this.i18n.generateUrlWithLang('client/addresses') },
      { label: 'client.navigation.account_settings', route: this.i18n.generateUrlWithLang('client/settings') }
    ];
  }
}
